"use client";

import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

export function Contact() {
  return (
    <section id="contact" className="relative px-6 md:px-12 py-32 border-t border-border overflow-hidden">
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground mb-8"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          [005] — The final move
        </motion.div>

        <motion.a
          href="mailto:hello@voidstudio.xyz"
          className="block group cursor-pointer"
          aria-label="Email hello@voidstudio.xyz"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2
            className="font-display uppercase leading-[0.82] tracking-[-0.03em] transition-transform duration-500 group-hover:translate-x-2"
            style={{ fontSize: "clamp(4rem, 16vw, 22rem)" }}
          >
            <span className="inline-block transition-colors duration-300 group-hover:text-[oklch(0.94_0.27_128)]">Let's</span>
            <br />
            <span className="text-[oklch(0.94_0.27_128)] italic font-serif normal-case transition-all duration-300 group-hover:text-outline-acid">
              record.
            </span>
          </h2>
        </motion.a>

        <motion.div
          className="mt-16 grid md:grid-cols-2 gap-12 items-end"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="font-serif text-2xl md:text-3xl text-muted-foreground max-w-xl leading-tight">
            Tell me what you're producing. I read every email — the good ones get a reply within 24 hours.
          </p>

          <div className="flex flex-col gap-6 md:items-end w-full">
            <a
              href="mailto:hello@voidstudio.xyz"
              className="btn-acid btn-magnetic px-8 md:px-16 py-6 md:py-10 text-lg sm:text-xl md:text-3xl acid-glow w-full md:w-auto text-center"
            >
              <span className="truncate">→ hello@voidstudio.xyz</span>
            </a>
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              Replies within 24 hours · Lisbon time
            </span>
          </div>
        </motion.div>

        <motion.footer
          className="mt-32 pt-8 border-t border-border flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-widest text-muted-foreground"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <span>© 2026 Void/Studio — Independent Practice</span>
          <span>Built with intent. No templates harmed.</span>
          <span>Lisbon ⇋ NYC ⇋ Internet</span>
        </motion.footer>
      </div>
    </section>
  );
}
